import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaUsers,
  FaUserGraduate,
  FaTasks,
  FaUserCircle
} from 'react-icons/fa';
import { DContext } from '../../../context/Datacontext';
import { fetchCardsCount } from '../../services/managerApi/fetchCardCount';
import FloatingLoading from '../../blocks/Layout/Loading';
import { renderCapitalize } from '../../../utils/renderCapitalize';

const cardsConfig = [
  { key: 'userManagement', title: 'User Management', icon: <FaUsers size={24} />, route: '/list-users' },
  { key: 'candidateManagement', title: 'Report Management', icon: <FaUserGraduate size={24} />, route: '/list-candidates' },
  // { key: 'JobManagement', title: 'Job Management', icon: <FaTasks size={24} />, route: '/list-jobs' },
  { key: 'account', title: 'My Account', icon: <FaUserCircle size={24} />, route: '/my-account' },
];

export default function HelpDeskDashboard() {
  const navigate = useNavigate();
  const { BeURL, showAlert, currentUser } = useContext(DContext);
  const [counts, setCounts] = useState({});

  // useEffect(() => {
  // fetch(`${BeURL}/admin/metrics`, { credentials: 'include' })
  //   .then(res => res.json())
  //   .then(data => {
  //     if (data.success) setCounts(data.metrics);
  //     else showAlert(data.message);
  //   })
  //   .catch(err => {
  //     console.error('Error fetching admin metrics:', err);
  //     showAlert('Unable to load dashboard metrics.');
  //   });
  // }, [BeURL, showAlert]);

  useEffect(() => {
    if (currentUser && BeURL) {
      const companyId = currentUser.companyId ? currentUser.companyId : currentUser.company.companyId
      fetchCardsCount(BeURL, showAlert, companyId, setCounts)
    }
  }, [BeURL, currentUser]);

  if (!BeURL || !currentUser) return <div className='min-h-[80vh]'><FloatingLoading /></div>

  return (
    <div className="min-h-[80vh] p-6">

      <h2 className="text-center text-2xl font-semibold text-primary-600 mb-8">
        HelpDesk Dashboard
      </h2>

      <div className=' flex justify-end mb-5 px-16'>

        {/* <button className='rounded-full px-4 py-1 text-md bg-secondary-500 hover:bg-secondary-600 text-white' onClick={() => navigate('/create-users')}>Create HelpDesk</button> */}

      </div>
      <div
        className="flex flex-wrap justify-center items-stretch gap-6"
        style={{ alignContent: 'center' }}
      >
        {cardsConfig.map(card => (
          <div
            key={card.key}
            onClick={() => navigate(card.route)}
            className="flex flex-col items-center justify-between w-full sm:w-[48%] lg:w-[22%] bg-white rounded-2xl shadow-lg hover:shadow-xl transition p-6 cursor-pointer"
          >
            <div className="p-4 rounded-full bg-blue-100 text-primary-500 mb-4">
              {card.icon}
            </div>
            <h3 className="text-3xl font-bold text-slate-800">
              {counts[card.key] ?? '--'}
            </h3>
            <p className="text-primary-400 mt-2 text-center text-lg font-medium">
              {renderCapitalize(card.title)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
